module.exports = __webpack_public_path__ + "img/img-head.8c8bfad2.png";